import { Injectable } from '@angular/core';
import { NavItem } from 'pmv-common';
import { environment } from '../environments/environment';

/**
 * Dados de configuração do sistema.
 */
@Injectable()
export class AppConfig {
  readonly title: string = `Processo Seletivo${environment.production ? '' : ' [dev]'}`;
  readonly version: string = '1.0.0';
  readonly serverPath: string = environment.api;
  readonly timeLogout: number = environment.timeLogout;
  readonly navItems: NavItem[] = [
    {
      label: 'Candidato', children: [
      { label: 'Alterar Dados', routerLink: ['candidato/update'] },
      { label: 'Minhas Inscrições', routerLink: ['candidato/acompanhamento'] },
      ]
    },
    {
      label: 'Editais', children: [
        { label: 'Pesquisar Editais', routerLink: ['edital'] },
      ]
    },
  ];
  readonly navItemsIntranet: NavItem[] = [
    {
      label: 'Avaliação Deficiente', children: [
        { label: 'Convocação/Avaliação', routerLink: ['avaliacao-deficiente'] },
      ]
    },
    {
      label: 'Classificação', children: [
        { label: 'Processar Classificação', routerLink: ['processar-classificacao'] },
      ]
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts